// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_9w-0";
export var optionCard = "_9w-1";